/**
 * 创建人：段锐
 * 时间：2019-7-01
 * 描述：视频播放组件
 * 使用说明: 参考 sw-video 配置应用说明文档
 * 更新记录: 
 */
import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { SwModalframeComponent } from '../sw-modal-frame/sw-modal-frame.component';
declare var $: any;

/**
 * 视频播放组件  sw-video
 * 使用方式 SwVideoService 服务 或者 SwVideoDirective
 */
@Component({
  selector: 'sw-video',
  templateUrl: './sw-video.component.html',
  styleUrls: ['./sw-video.component.css']
})
export class SwVideoComponent implements OnInit {

  /**
   * @ignore
   */
  constructor() { $(".videoBox").removeClass("hidden"); }

  /**
   * @ignore
   */
  ngOnInit() {
  }
  /**
   * 文件名
   */
  @Input() title: string = "";
  /**
   * 路径
   */
  @Input() src: string;

  /**
   * 销毁组建事件
   */
  @Output() voted = new EventEmitter();

  /**
   * 模态框
   * @ignore
   */
  @ViewChild('videoModal') videoModal: SwModalframeComponent; 


  /**
   * 打开音频方法
   * @ignore
   */
  openVideo() {
    $(".videoBox").removeClass("hidden");
  }

  /**
   * 关闭音频方法
   */
  closeVideo() {
    this.voted.emit(true)
  }

  //点击关闭模态框
  close(){
    this.videoModal.toggle() //关闭模态框
  }

}
